<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.Companies.InfoWidget.UpdateLogo.Title">
  <ng-container commands>
    <button class="btn btn-success me-2" (click)="save()" [disabled]="!base64img">
      {{'Screens.Companies.InfoWidget.UpdateLogo.Apply' | translate}}
    </button>
    <button class="btn btn-default me-4" (click)="goBack()">
      {{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}
    </button>
  </ng-container>
  <ng-container body>
    <tcm-details-layout>
      <div form-area class="draggable">
        <div class="tcm-details-panel">
          <picture-loader (pictureLoaded)="onPictureLoaded($event)">
            <div upload-picture-button></div>
            <img image-container class="image-container"
                 src="{{base64img || '/assets/images/no-photo.jpg'}}" />
          </picture-loader>
        </div>
      </div>
    </tcm-details-layout>
  </ng-container>
</tcm-main-frame>
